export default {
  IRIS: 'iris',
  LISTINGS: 'Listings',
  ACTIVITY_TAB: 'ActivityTab',
  EDIT_LISTING: 'EditListing',
  ADD_NEW_LISTING: 'AddNewListing',
  MY_LISTINGS: 'MyListings',
  TASKBOARD: 'Taskboard',
  TASKBOARD_POPUP: 'taskboardPopup',
  REVIEW: 'review',
  FILES: 'files',
  COMMENTS: 'comments',
};
